export const EMPTY_USERS = 'Search/EMPTY_USERS';

export const FETCH_USERS = 'Search/FETCH_USERS';
export const FETCH_USERS_SUCCESS = 'Search/FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'Search/FETCH_USERS_FAILURE';

export const SAVE_COMPANY_SUBSCRIPTION_START = 'Users/SAVE_COMPANY_SUBSCRIPTION_START';
export const SAVE_COMPANY_SUBSCRIPTION_SUCCESS = 'Users/SAVE_COMPANY_SUBSCRIPTION_SUCCESS';
export const SAVE_COMPANY_SUBSCRIPTION_FAILURE = 'Users/SAVE_COMPANY_SUBSCRIPTION_FAILURE';

export const SAVE_USER_STATUS_START = 'Users/SAVE_USER_STATUS_START';
export const SAVE_USER_STATUS_SUCCESS = 'Users/SAVE_USER_STATUS_SUCCESS';
export const SAVE_USER_STATUS_FAILURE = 'Users/SAVE_USER_STATUS_FAILURE';

export const SET_USERS = 'Search/SET_USERS';



// WEBPACK FOOTER //
// ./src/containers/Users/store/constants.js